/* eslint-disable no-unused-vars */

export const DDDLowSymbolNames = {
    L1: `L1`,
    L2: `L2`,
    L3: `L3`,
    L4: `L4`,
    L5: `L5`,
} as const;

// eslint-disable-next-line no-redeclare
export type DDDLowSymbolNames = (typeof DDDLowSymbolNames)[keyof typeof DDDLowSymbolNames];

export const DDDHighSymbolNames = {
    M1: `M1`,
    M2: `M2`,
    M3: `M3`,
    M4: `M4`,
    M5: `M5`,
} as const;

// eslint-disable-next-line no-redeclare
export type DDDHighSymbolNames = (typeof DDDHighSymbolNames)[keyof typeof DDDHighSymbolNames];

export const DDDSpecialSymbolNames = {
    WILD: `W`,
    SCATTER: `S`,
    XN_1: `XN_1`,
    XN_2: `XN_2`,
    XN_3: `XN_3`,
    XGOD_1: `B_1`,
    XGOD_2: `B_2`,
    XGOD_3: `B_3`,
} as const;

// eslint-disable-next-line no-redeclare
export type DDDSpecialSymbolNames =
    (typeof DDDSpecialSymbolNames)[keyof typeof DDDSpecialSymbolNames];

export const DDDSymbolNames = {
    ...DDDLowSymbolNames,
    ...DDDHighSymbolNames,
    ...DDDSpecialSymbolNames,
} as const;

// eslint-disable-next-line no-redeclare
export type DDDSymbolNames = (typeof DDDSymbolNames)[keyof typeof DDDSymbolNames];

// * if wild then full
export enum DDDSymbolSize {
    X033 = 0.33,
    X075 = 0.75,
    X1 = 1,
    X2 = 2,
    X3 = 3,
    X4 = 4,
}
